<script lang="ts">
  import type { UserLessonOrCheckpointStore } from 'shared/src/user/userLessons/user.lessonOrCheckpoint.store';
  import { dateString, dateTimeString } from 'shared/src/utils/date.utils';
  import { onDestroy } from 'svelte';
  import { autorun } from 'mobx';
  import Dot from '$lib/components/Dot.svelte';
  export let lessonOrCheckpointStore: UserLessonOrCheckpointStore;

  let props: {
    isDueDateVisible: boolean;
    isLate: boolean;
    isComplete: boolean;
    dueDate: Date | undefined;
    dueDateString: string;
    gradePenalty: number;
  };

  const destroyer = autorun(() => {
    const dueDate = lessonOrCheckpointStore.dueDate;
    const dueDateString = dueDate
      ? `${dateString(dueDate)} at ${dateTimeString(dueDate, {
          hour: 'numeric',
          minute: '2-digit',
        })}`
      : '';

    props = {
      isDueDateVisible: lessonOrCheckpointStore.isDueDateVisible,
      isLate: lessonOrCheckpointStore.isLate,
      isComplete: lessonOrCheckpointStore.isComplete,
      dueDate,
      dueDateString,
      gradePenalty: lessonOrCheckpointStore.gradePenalty,
    };
  });

  onDestroy(destroyer);
</script>

{#if props.isDueDateVisible && (props.isLate || !props.isComplete)}
  <p class:deadline-missed={props.isLate}>
    <Dot class={props.isLate ? 'text-red' : 'text-orange'} />
    Due: {props.dueDateString}
    {#if props.isLate && props.gradePenalty}
      ({props.isComplete ? 'late' : 'overdue'}, {props.gradePenalty}% deduction)
    {:else if props.isLate && !props.gradePenalty}
      ({props.isComplete ? 'late' : 'overdue'})
    {/if}
  </p>
{/if}
